// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConnectVerificationModal_wrapper__0ltOo","error":"ConnectVerificationModal_error__HUIaU","visible":"ConnectVerificationModal_visible__jKSgV"};